export const ventures = [
  {
    name: 'JT Innovation',
    slug: 'jt-innovation',
    tagline: 'Prozessoptimierung, Digitalisierung und Automatisierung für effizientere Abläufe.',
    description: 'JT Innovation unterstützt Unternehmen dabei, Prozesse zu vereinfachen, manuelle Aufwände zu reduzieren und Digitalisierung so umzusetzen, dass im Alltag spürbare Entlastung entsteht.',
    focus: ['Prozessoptimierung', 'Digitalisierung', 'Automatisierung'],
    status: 'Aktiv',
    ctaLabel: 'Mehr erfahren',
    href: 'https://jtinnovation.de',
    external: true,
    featured: true
  },
  {
    name: 'JT MVP Studio',
    slug: 'jt-mvp-studio',
    tagline: 'MVPs, Prototypen und produktnahe Umsetzung für neue Vorhaben und nächste Releases.',
    description: 'JT MVP Studio hilft Teams, Ideen schneller in greifbare Ergebnisse zu überführen – von der Validierung bis zum umsetzbaren MVP oder nächsten sinnvollen Release-Schritt.',
    focus: ['Validation Track', 'Build Track', 'Iteration Track'],
    status: 'Aktiv',
    ctaLabel: 'Mehr erfahren',
    href: 'https://jtmvpstudio.jtinnovation.de',
    external: true,
    featured: true
  },
  {
    name: 'JT AI Advisory',
    slug: 'jt-ai-advisory',
    tagline: 'Strategische KI-Beratung mit Fokus auf Einordnung, Priorisierung und Umsetzung.',
    description: 'JT AI Advisory unterstützt Unternehmen dabei, KI-Chancen realistisch zu bewerten, sinnvolle Prioritäten zu setzen und aus Ideen tragfähige Anwendungsfälle zu machen.',
    focus: ['AI Strategy', 'AI Automation', 'AI Visibility'],
    status: 'Aktiv',
    ctaLabel: 'Mehr erfahren',
    href: 'https://jtaiadvisory.jtinnovation.de',
    external: true,
    featured: true
  },
  {
    name: 'JT Medical Consulting',
    slug: 'jt-medical-consulting',
    tagline: 'Beratung für medizinische und gesundheitsnahe Kontexte mit klarem Praxisbezug.',
    description: 'JT Medical Consulting unterstützt medizinische Einrichtungen und gesundheitsnahe Angebote dabei, Prozesse, Digitalisierung und IT-Strukturen praxistauglich weiterzuentwickeln.',
    focus: ['Medizinische Prozesse', 'Digitalisierung', 'Praktikable IT-Setups'],
    status: 'Aktiv',
    ctaLabel: 'Mehr erfahren',
    href: 'https://jtmedicalconsulting.jtinnovation.de',
    external: true,
    featured: false
  },
  {
    name: 'manaforgeai',
    slug: 'manaforgeai',
    tagline: 'AI-native Systeme, Anwendungen und Workflows für neue digitale Lösungen.',
    description: 'manaforgeai steht für AI-native Systeme und Workflows, mit denen aus neuen technologischen Möglichkeiten konkrete Anwendungen und digitale Lösungen werden.',
    focus: ['AI Products', 'Workflow Systems', 'Platform Thinking'],
    status: 'Aktiv',
    ctaLabel: 'Mehr erfahren',
    href: 'https://manaforgeai.de',
    external: true,
    featured: false
  },
  {
    name: 'JT Focus',
    slug: 'jtfocus',
    tagline: 'Self-hosted Projektmanagement mit klarem Fokus auf Kontrolle, Einfachheit und Unabhängigkeit.',
    description: 'JT Focus ist ein Projektmanagement-Produkt für Teams, die ihre Planung auf eigener Infrastruktur betreiben und dabei bewusst auf Übersicht, Unabhängigkeit und klare Abläufe setzen möchten.',
    focus: ['Self-Hosted PM', 'Kanban Sprint Gantt', 'No Vendor Lock-in'],
    status: 'Produkt im Ausbau',
    ctaLabel: 'Mehr erfahren',
    href: 'https://jtfocus.jtinnovation.de',
    external: true,
    featured: false
  },
  {
    name: 'Atlassian Archiv Suite',
    slug: 'atlassian-archiv',
    tagline: 'Apps für strukturierte Archivierung in Jira und Confluence.',
    description: 'Die Atlassian Archiv Suite hilft dabei, Jira- und Confluence-Daten sauber zu archivieren und gewachsene Bestände wieder übersichtlicher zu machen.',
    focus: ['Jira Archiving', 'Confluence Archiving', 'Atlassian Apps'],
    status: 'Verfügbar',
    ctaLabel: 'Mehr erfahren',
    href: 'https://atlassian-archiv.jtinnovation.de',
    external: true,
    featured: false
  }
];

export function getVentureBySlug(slug) {
  return ventures.find((venture) => venture.slug === slug);
}
